module.exports = __webpack_public_path__ + "img/ysblogo.eb645e64.png";